module.exports = "/_next/static/images/60825457fbd6e013465a0c9b6a115dd8-ticket-01-02.png.webp";